// extracted by mini-css-extract-plugin
export default {"search":"press-secretaries_search__IVMrh","field":"press-secretaries_field__l6tsT","list":"press-secretaries_list__Tjbno"};